import React from 'react'

export const JoinBy = ({ args, children, Delimiter }) =>
  (children || args).map((child, index) => (
    <React.Fragment key={index}>
      {Boolean(index) && Delimiter}
      {child}
    </React.Fragment>
  ))
